import type { Project, ProjectAccessLevel, ProjectDto } from "./types";

const PROJECT_ACCESS_LEVELS = new Set<ProjectAccessLevel>([
  "owner",
  "admin",
  "modifier",
  "viewer",
]);

const normalizeAccessLevel = (
  accessLevel: string | null | undefined,
): ProjectAccessLevel | null =>
  PROJECT_ACCESS_LEVELS.has(accessLevel as ProjectAccessLevel)
    ? (accessLevel as ProjectAccessLevel)
    : null;

export const normalizeProjectDto = (project: ProjectDto): Project => ({
  id: project.id,
  name: project.name,
  description: project.description ?? "",
  isOwner: project.is_owner === true,
  accessLevel: normalizeAccessLevel(project.access_level),
  createdAt: project.created_at ?? null,
  apProjectId: project.ap_project_id ?? null,
  organizationId: project.organization_id ?? null,
  userId: project.user_id ?? null,
});

export const normalizeProjectDtos = (projects: ProjectDto[]): Project[] =>
  projects.map(normalizeProjectDto);
